// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Перекрашиваем навигацию слайдера */
:root {
  --swiper-navigation-color: #62a744;
  --swiper-theme-color: #62a744;

  --swiper-pagination-color: #62a744;
  /* --swiper-pagination-bullet-inactive-color: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 1) 48%, rgba(0, 0, 0, 1) 50%, rgba(98, 167, 68, 1) 60%); */
  --swiper-pagination-bullet-inactive-color: #c7c7c7;
  --swiper-pagination-bullet-inactive-opacity: 1;

  --swiper-pagination-bullet-width: 14px;
  --swiper-pagination-bullet-height: 14px;
  --swiper-pagination-bullet-size: 14px;
}

.feed p.bold {
  font-weight: bold;
}
.feed p.italic {
  font-style: italic;
}

.feed a,
.feed blockquote a p {
  color: #62a744 !important;
}

.feed a {
  cursor: pointer;
}

.feed a p.bold {
  display: inline;
  color: rgb(106, 65, 146);
  text-decoration: none;
}

.wrapper {
  width: 100%;
  max-width: 1200px;
  margin-inline: auto;
  padding-top: 20px;
  padding-bottom: 40px;
  font-size: 18px;
  line-height: 1.55;
  color: #313131;
  box-sizing: border-box;
}
.wrapper.limited input[type="date"] {
  border: 1px solid black;
}

.wrapper.limited {
  padding-inline: 20px;
}

.feed {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 60px;

  overflow: hidden;
}

.feed p,
.feed h1 {
  line-height: 1.55;
  color: #313131;
  display: inline;
}

p.news_date,
.feed a,
.feed p,
.feed .t-redactor__text,
.feed .t-redactor__quote,
.feed ul {
  font-size: clamp(16px, 2vw, 26px);
}

.feed h4,
.feed h2 {
  font-size: 28px;
  line-height: 1.3;
  font-weight: bold;
  margin-block: 2em 0.75em;
}

.feed h1 {
  font-size: clamp(28px, 4vw, 60px);
  line-height: 1.23;
  font-weight: 600;
}

.feed figure {
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  margin: 0;
}

.feed img {
  width: 100%;
  box-sizing: border-box;
  max-height: 700px;
  object-fit: cover;
  border-radius: 20px;
}

.feed .zoomable {
  object-fit: contain;
  cursor: zoom-in;
}

.feed swiper-slide img {
  object-fit: contain;
}

.feed swiper-slide {
  cursor: zoom-in;
}

.feed .zooming_chart.active,
.feed [data-block="gallery"].active {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  z-index: 999999;
}

.feed .zooming_chart.active img,
.feed [data-block="gallery"].active swiper-slide {
  cursor: default;
}

.feed [data-block="gallery"].active swiper-slide img {
  max-height: 900px;
  padding: 20px;
}

.feed .zooming_chart.active img {
  /* max-height: none; */
  max-height: -webkit-fill-available;
  width: -webkit-max-content;
  width: max-content;
  padding: 20px;
}

/* .feed figure > img {
  width: 100%;

  max-height: 700px;
  object-fit: cover;
} */

.feed ul {
  list-style-type: disc !important;
  /* padding-left: 20px; */
  padding-left: 46px !important;
}

.feed ol {
  padding-left: 46px !important;
}

.feed .t-redactor__text {
  line-height: 1.55;
}
.feed .t-redactor__preface * {
  font-size: 26px;
  line-height: 1.55;
}

.feed .t-redactor__quote {
  padding-left: 20px;
  border-left: 3px solid rgba(0, 0, 0, 0.84);

  font-style: italic;
}

.feed .t-redactor__callout {
	display: flex;
	align-items: center;
	justify-content: initial;
	padding: 20px;
	background-color: #ebebeb;
	gap: 12px;
}

.feed .t-redactor__callout .t-redactor__callout-icon {
	display: flex;
}

.feed .video_wrapper {
  max-height: 500px;
}

.feed .video_wrapper video {
  width: 100%;
  height: 100%;
  max-height: inherit;
  /* object-fit: cover; */
  object-fit: contain;
}

.wrapper nav {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 24px;
}
.wrapper nav a {
  line-height: 100% !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  transition: all 0.5s;
  padding: 18px 12px;
}

.wrapper nav a:hover {
  background-color: #e8e8e8 !important;
  border-radius: 10px;
}

.wrapper nav a svg {
  background-color: transparent !important;
}

.wrapper nav a p {
  color: #62a744 !important;
  background-color: transparent !important;
}

.filter {
  padding-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  /*position: absolute;*/
  /*top: 150px;*/
  /*position: sticky;*/
  top: 20px;
  z-index: 2;
}

.filter .filter_wrapper {
  display: flex;
  gap: 12px;
  align-items: center;
}

.filter .filter_wrapper > input {
  padding: 10px;
  background: rgba(34, 34, 34, 0.04);
  border-radius: 6px;
  border: none;

  /*outline: 6px solid #fff;*/
  /*    -webkit-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/
  /*-moz-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/
  /*box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/
}

.wrapper.limited .filter .filter_wrapper > input {
  border: 2px solid #000000;
}
/*.filter > div {*/
/*    cursor: pointer;*/
/*    height: 40px;*/
/*    background-color: #fff;*/
/*    border-radius: 50%;*/
/*    -webkit-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/
/*-moz-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/
/*box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/
/*}*/
.goUp {
  height: 100%;
  transform: rotateZ(90deg);
}

swiper-container {
  width: 100%;
}
swiper-slide img {
  display: block;
  width: 100%;
}
swiper-slide {
  height: auto;
  display: flex;
  align-items: center;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.news_dateTag-wrapper {
  margin-block: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}

.news_dateTag-wrapper .news__tag {
  border-radius: 10px;
  padding: 6px 12px;
  font-weight: 300;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  color: #000;
  background: #e8e8e8;
}

.wrapper.limited .news_dateTag-wrapper .news__tag {
	border-radius: 0;
	border-radius: initial;
	background: #e8e8e8 !important;
}

p.news_date {
  margin-block: 10px;
  display: block;
}

.feed header a.news_source {
  display: block;
  margin-bottom: 18px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
}

.separator {
  margin-top: 40px;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #f5f6f7, rgb(200, 200, 200), #f5f6f7);
}

.showMoreButton {
  margin: 0 auto !important;
  display: block;
  font-family: "MoscowSans", Arial, sans-serif !important;
  box-sizing: border-box;
  padding: 20px 60px;
  color: #ffffff !important;
  background-color: #000000 !important;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin: 45px auto 0 auto;
  cursor: pointer;
  transition: all 0.3s;
}
.showMoreButton:hover {
  background-color: #62a744 !important;
}

.showMoreButton.limited {
  color: #000000 !important;
  border: 2px solid black !important;
}

.showMoreButton.limited:hover {
  color: #ffffff !important;
}

@media (max-width: 1550px) {
  .wrapper {
    max-width: none;
    max-width: initial;
    margin-inline: unset;
  }
}

@media (max-width: 1370px) {
  .feed img {
    max-height: 600px;
  }
}

@media (max-width: 1180px) {
  .feed img {
    max-height: 400px;
  }
}

@media (max-width: 900px) {
  .wrapper {
    width: 100%;
    font-size: 16px;
  }
  .feed h4 {
    font-size: 20px;
  }

  .feed .t-redactor__text,
  .feed .t-redactor__text * {
    font-size: 16px;
  }
  .feed .t-redactor__quote,
  .feed .t-redactor__quote *,
  .feed .t-redactor__callout,
  .feed .t-redactor__callout *  {
    font-size: 16px;
  }
  .feed .t-redactor__preface,
  .feed .t-redactor__preface * {
    font-size: 24px;
  }
}

@media (max-width: 640px) {
  .wrapper {
    font-size: 14px;

    padding-inline: 20px;
  }
  .feed h4 {
    font-size: 18px;
  }

  .feed .news_date,
  .feed .news_source {
    font-size: 16px;
  }

  .news_dateTag-wrapper .news__tag {
    font-size: 14px !important;
  }

  .feed .t-redactor__preface,
  .feed .t-redactor__preface * {
    font-size: 22px;
  }

  .feed ul,
  .feed ol {
    padding-left: 28px !important;
  }

  .feed img {
    border-radius: 10px;
  }
}

@media (max-width: 479px) {
  .feed ul,
  .feed ol {
    padding-left: 32px !important;
  }
}

@media (max-width: 440px) {
  .wrapper.limited {
    padding-top: 42px;
  }

  .filter .filter_wrapper {
    gap: 6px;
  }

  .filter .filter_wrapper > input {
    width: 108px;
    font-size: 12px;
    padding: 10px 5px;
  }

  .feed [data-block="gallery"].active swiper-slide img,
  .feed .zooming_chart.active img {
    padding: 10px;
  }

  .feed .t-redactor__callout {
    padding: 10px;
  }

  .wrapper.limited .filter .filter_wrapper > input {
    width: 132px;
  }
}

@media (max-width: 390px) {
  .filter .filter_wrapper > input {
    width: 90px;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kCAAkC;EAClC,6BAA6B;;EAE7B,kCAAkC;EAClC,yJAAyJ;EACzJ,kDAAkD;EAClD,8CAA8C;;EAE9C,sCAAsC;EACtC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,0BAAkB;EAAlB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;;GAKG;;AAEH;EACE,gCAAgC;EAChC,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;;EAE1C,kBAAkB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,wBAAsB;CACtB,aAAa;CACb,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;;EAEZ,2BAA2B;EAC3B,wEAAwE;EACxE,iEAAiE;EACjE,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;AAC3B;AACA,kBAAkB;AAClB,uBAAuB;AACvB,oBAAoB;AACpB,8BAA8B;AAC9B,0BAA0B;AAC1B,wEAAwE;AACxE,iEAAiE;AACjE,4DAA4D;AAC5D,IAAI;AACJ;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAAmB;EAAnB,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;CACC,gBAAoB;CAApB,sBAAoB;CACpB,8BAA8B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EAQX,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uDAAuD;EACvD,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAgB;IAAhB,kBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;EACA;;;;IAIE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;;IAEf,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* Перекрашиваем навигацию слайдера */\r\n:root {\r\n  --swiper-navigation-color: #62a744;\r\n  --swiper-theme-color: #62a744;\r\n\r\n  --swiper-pagination-color: #62a744;\r\n  /* --swiper-pagination-bullet-inactive-color: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 1) 48%, rgba(0, 0, 0, 1) 50%, rgba(98, 167, 68, 1) 60%); */\r\n  --swiper-pagination-bullet-inactive-color: #c7c7c7;\r\n  --swiper-pagination-bullet-inactive-opacity: 1;\r\n\r\n  --swiper-pagination-bullet-width: 14px;\r\n  --swiper-pagination-bullet-height: 14px;\r\n  --swiper-pagination-bullet-size: 14px;\r\n}\r\n\r\n.feed p.bold {\r\n  font-weight: bold;\r\n}\r\n.feed p.italic {\r\n  font-style: italic;\r\n}\r\n\r\n.feed a,\r\n.feed blockquote a p {\r\n  color: #62a744 !important;\r\n}\r\n\r\n.feed a {\r\n  cursor: pointer;\r\n}\r\n\r\n.feed a p.bold {\r\n  display: inline;\r\n  color: rgb(106, 65, 146);\r\n  text-decoration: none;\r\n}\r\n\r\n.wrapper {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  margin-inline: auto;\r\n  padding-top: 20px;\r\n  padding-bottom: 40px;\r\n  font-size: 18px;\r\n  line-height: 1.55;\r\n  color: #313131;\r\n  box-sizing: border-box;\r\n}\r\n.wrapper.limited input[type=\"date\"] {\r\n  border: 1px solid black;\r\n}\r\n\r\n.wrapper.limited {\r\n  padding-inline: 20px;\r\n}\r\n\r\n.feed {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  margin-bottom: 60px;\r\n\r\n  overflow: hidden;\r\n}\r\n\r\n.feed p,\r\n.feed h1 {\r\n  line-height: 1.55;\r\n  color: #313131;\r\n  display: inline;\r\n}\r\n\r\np.news_date,\r\n.feed a,\r\n.feed p,\r\n.feed .t-redactor__text,\r\n.feed .t-redactor__quote,\r\n.feed ul {\r\n  font-size: clamp(16px, 2vw, 26px);\r\n}\r\n\r\n.feed h4,\r\n.feed h2 {\r\n  font-size: 28px;\r\n  line-height: 1.3;\r\n  font-weight: bold;\r\n  margin-block: 2em 0.75em;\r\n}\r\n\r\n.feed h1 {\r\n  font-size: clamp(28px, 4vw, 60px);\r\n  line-height: 1.23;\r\n  font-weight: 600;\r\n}\r\n\r\n.feed figure {\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.feed img {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  max-height: 700px;\r\n  object-fit: cover;\r\n  border-radius: 20px;\r\n}\r\n\r\n.feed .zoomable {\r\n  object-fit: contain;\r\n  cursor: zoom-in;\r\n}\r\n\r\n.feed swiper-slide img {\r\n  object-fit: contain;\r\n}\r\n\r\n.feed swiper-slide {\r\n  cursor: zoom-in;\r\n}\r\n\r\n.feed .zooming_chart.active,\r\n.feed [data-block=\"gallery\"].active {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #ffffff;\r\n  z-index: 999999;\r\n}\r\n\r\n.feed .zooming_chart.active img,\r\n.feed [data-block=\"gallery\"].active swiper-slide {\r\n  cursor: default;\r\n}\r\n\r\n.feed [data-block=\"gallery\"].active swiper-slide img {\r\n  max-height: 900px;\r\n  padding: 20px;\r\n}\r\n\r\n.feed .zooming_chart.active img {\r\n  /* max-height: none; */\r\n  max-height: -webkit-fill-available;\r\n  width: max-content;\r\n  padding: 20px;\r\n}\r\n\r\n/* .feed figure > img {\r\n  width: 100%;\r\n\r\n  max-height: 700px;\r\n  object-fit: cover;\r\n} */\r\n\r\n.feed ul {\r\n  list-style-type: disc !important;\r\n  /* padding-left: 20px; */\r\n  padding-left: 46px !important;\r\n}\r\n\r\n.feed ol {\r\n  padding-left: 46px !important;\r\n}\r\n\r\n.feed .t-redactor__text {\r\n  line-height: 1.55;\r\n}\r\n.feed .t-redactor__preface * {\r\n  font-size: 26px;\r\n  line-height: 1.55;\r\n}\r\n\r\n.feed .t-redactor__quote {\r\n  padding-left: 20px;\r\n  border-left: 3px solid rgba(0, 0, 0, 0.84);\r\n\r\n  font-style: italic;\r\n}\r\n\r\n.feed .t-redactor__callout {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: unset;\r\n\tpadding: 20px;\r\n\tbackground-color: #ebebeb;\r\n\tgap: 12px;\r\n}\r\n\r\n.feed .t-redactor__callout .t-redactor__callout-icon {\r\n\tdisplay: flex;\r\n}\r\n\r\n.feed .video_wrapper {\r\n  max-height: 500px;\r\n}\r\n\r\n.feed .video_wrapper video {\r\n  width: 100%;\r\n  height: 100%;\r\n  max-height: inherit;\r\n  /* object-fit: cover; */\r\n  object-fit: contain;\r\n}\r\n\r\n.wrapper nav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-bottom: 24px;\r\n}\r\n.wrapper nav a {\r\n  line-height: 100% !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  gap: 8px !important;\r\n  transition: all 0.5s;\r\n  padding: 18px 12px;\r\n}\r\n\r\n.wrapper nav a:hover {\r\n  background-color: #e8e8e8 !important;\r\n  border-radius: 10px;\r\n}\r\n\r\n.wrapper nav a svg {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.wrapper nav a p {\r\n  color: #62a744 !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.filter {\r\n  padding-bottom: 30px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n  /*position: absolute;*/\r\n  /*top: 150px;*/\r\n  /*position: sticky;*/\r\n  top: 20px;\r\n  z-index: 2;\r\n}\r\n\r\n.filter .filter_wrapper {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.filter .filter_wrapper > input {\r\n  padding: 10px;\r\n  background: rgba(34, 34, 34, 0.04);\r\n  border-radius: 6px;\r\n  border: none;\r\n\r\n  /*outline: 6px solid #fff;*/\r\n  /*    -webkit-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/\r\n  /*-moz-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/\r\n  /*box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/\r\n}\r\n\r\n.wrapper.limited .filter .filter_wrapper > input {\r\n  border: 2px solid #000000;\r\n}\r\n/*.filter > div {*/\r\n/*    cursor: pointer;*/\r\n/*    height: 40px;*/\r\n/*    background-color: #fff;*/\r\n/*    border-radius: 50%;*/\r\n/*    -webkit-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/\r\n/*-moz-box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/\r\n/*box-shadow: 1px 4px 100px 10px rgba(255, 255, 255, 0.81);*/\r\n/*}*/\r\n.goUp {\r\n  height: 100%;\r\n  transform: rotateZ(90deg);\r\n}\r\n\r\nswiper-container {\r\n  width: 100%;\r\n}\r\nswiper-slide img {\r\n  display: block;\r\n  width: 100%;\r\n}\r\nswiper-slide {\r\n  height: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  height: fit-content;\r\n}\r\n\r\n.news_dateTag-wrapper {\r\n  margin-block: 10px;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.news_dateTag-wrapper .news__tag {\r\n  border-radius: 10px;\r\n  padding: 6px 12px;\r\n  font-weight: 300;\r\n  width: fit-content;\r\n  color: #000;\r\n  background: #e8e8e8;\r\n}\r\n\r\n.wrapper.limited .news_dateTag-wrapper .news__tag {\r\n\tborder-radius: unset;\r\n\tbackground: #e8e8e8 !important;\r\n}\r\n\r\np.news_date {\r\n  margin-block: 10px;\r\n  display: block;\r\n}\r\n\r\n.feed header a.news_source {\r\n  display: block;\r\n  margin-bottom: 18px;\r\n  width: fit-content;\r\n  cursor: pointer;\r\n}\r\n\r\n.separator {\r\n  margin-top: 40px;\r\n  width: 100%;\r\n  height: 2px;\r\n  background: -webkit-linear-gradient(\r\n    90deg,\r\n    #f5f6f7,\r\n    rgb(200, 200, 200),\r\n    #f5f6f7\r\n  );\r\n  background: -moz-linear-gradient(90deg, #f5f6f7, rgb(200, 200, 200), #f5f6f7);\r\n  background: linear-gradient(90deg, #f5f6f7, rgb(200, 200, 200), #f5f6f7);\r\n}\r\n\r\n.showMoreButton {\r\n  margin: 0 auto !important;\r\n  display: block;\r\n  font-family: \"MoscowSans\", Arial, sans-serif !important;\r\n  box-sizing: border-box;\r\n  padding: 20px 60px;\r\n  color: #ffffff !important;\r\n  background-color: #000000 !important;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  border: none;\r\n  margin: 45px auto 0 auto;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n.showMoreButton:hover {\r\n  background-color: #62a744 !important;\r\n}\r\n\r\n.showMoreButton.limited {\r\n  color: #000000 !important;\r\n  border: 2px solid black !important;\r\n}\r\n\r\n.showMoreButton.limited:hover {\r\n  color: #ffffff !important;\r\n}\r\n\r\n@media (max-width: 1550px) {\r\n  .wrapper {\r\n    max-width: unset;\r\n    margin-inline: unset;\r\n  }\r\n}\r\n\r\n@media (max-width: 1370px) {\r\n  .feed img {\r\n    max-height: 600px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1180px) {\r\n  .feed img {\r\n    max-height: 400px;\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .wrapper {\r\n    width: 100%;\r\n    font-size: 16px;\r\n  }\r\n  .feed h4 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .feed .t-redactor__text,\r\n  .feed .t-redactor__text * {\r\n    font-size: 16px;\r\n  }\r\n  .feed .t-redactor__quote,\r\n  .feed .t-redactor__quote *,\r\n  .feed .t-redactor__callout,\r\n  .feed .t-redactor__callout *  {\r\n    font-size: 16px;\r\n  }\r\n  .feed .t-redactor__preface,\r\n  .feed .t-redactor__preface * {\r\n    font-size: 24px;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .wrapper {\r\n    font-size: 14px;\r\n\r\n    padding-inline: 20px;\r\n  }\r\n  .feed h4 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .feed .news_date,\r\n  .feed .news_source {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .news_dateTag-wrapper .news__tag {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .feed .t-redactor__preface,\r\n  .feed .t-redactor__preface * {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .feed ul,\r\n  .feed ol {\r\n    padding-left: 28px !important;\r\n  }\r\n\r\n  .feed img {\r\n    border-radius: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 479px) {\r\n  .feed ul,\r\n  .feed ol {\r\n    padding-left: 32px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 440px) {\r\n  .wrapper.limited {\r\n    padding-top: 42px;\r\n  }\r\n\r\n  .filter .filter_wrapper {\r\n    gap: 6px;\r\n  }\r\n\r\n  .filter .filter_wrapper > input {\r\n    width: 108px;\r\n    font-size: 12px;\r\n    padding: 10px 5px;\r\n  }\r\n\r\n  .feed [data-block=\"gallery\"].active swiper-slide img,\r\n  .feed .zooming_chart.active img {\r\n    padding: 10px;\r\n  }\r\n\r\n  .feed .t-redactor__callout {\r\n    padding: 10px;\r\n  }\r\n\r\n  .wrapper.limited .filter .filter_wrapper > input {\r\n    width: 132px;\r\n  }\r\n}\r\n\r\n@media (max-width: 390px) {\r\n  .filter .filter_wrapper > input {\r\n    width: 90px;\r\n    font-size: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
